import { Tooltip, TooltipContent, TooltipTrigger } from "@screener/uikit/components/tooltip";
import { cn } from "@screener/uikit/lib/utils";

/** Подсказка отметки «без данных» — одна на плашку таблицы и значок карточки. */
export const STALE_HINT = "Инструмент перестал отдавать данные: значения последние известные.";

/**
 * Плашка «без данных» — устаревание строки названо словом, а не одной лишь
 * прозрачностью: `Pending` §9 занят тем же каналом приглушённого цвета, и на
 * глаз два случая неразличимы. Общий компонент у строки таблицы и строки
 * карточки (review блок C) — обе показывают одно и то же предупреждение
 * одними и теми же словами.
 */
export function StaleMark({ className }: { className?: string }) {
  return (
    <Tooltip>
      <TooltipTrigger render={<span className={cn("text-warning", className)} />}>
        без данных
      </TooltipTrigger>
      <TooltipContent>{STALE_HINT}</TooltipContent>
    </Tooltip>
  );
}
